import './styles/details-section.scss'

import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import classnames from 'classnames'

class DetailsSection extends React.Component {
  static propTypes = {
    title:        PropTypes.string.isRequired,
    name:         PropTypes.string,
    description:  PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array
    ]),
    url:          PropTypes.string,
    user:         PropTypes.object,
    featureFlags: PropTypes.array.isRequired,
    children:     PropTypes.node,
  }

  state = {
    initted: false,
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ initted: true })
    }, 10)
  }

  render() {
    const { title, name, description, url } = this.props
    const { initted } = this.state

    const className        = classnames('details-section', { initted })
    const descriptionClass = classnames('description', { padded: !name })

    return (
      <div className={className}>
        <div className="title">{title}</div>

        {name && (
          <div className="name">
            {  url && <Link to={url}>{name}</Link> }
            { !url && <span>{name}</span> }
          </div>
        )}

        <div className={descriptionClass}>{description}</div>
        <div>
          { this.props.children }
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = {}
const mapStateToProps    = (state) => ({
  user:          state.auth.user,
  featureFlags:  state.features.featureFlags,
})

export default connect(mapStateToProps, mapDispatchToProps)(DetailsSection)
